/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { User, UsersData } from '../models/common/users';
import { tap } from 'rxjs/operators';
import { UserStore } from './user.store';
import { Injectable } from '@angular/core';
import { NbJSThemesRegistry, NbThemeService } from '@nebular/theme';
// import * as Sentry from "@sentry/angular-ivy";

@Injectable()
export class InitUserService {
    constructor(protected userStore: UserStore,
        protected usersService: UsersData,
        protected jsThemes: NbJSThemesRegistry,
        protected themeService: NbThemeService) { }

    initCurrentUser(): Promise<User> {
      return this.usersService.getProfile()
            .then((user: User) => {
                if (user) {
                  this.userStore.setUser(user);

                  if (user.settings && user.settings.themeName) {
                    if (this.jsThemes.has(user.settings.themeName)
                      && !!this.jsThemes.get(user.settings.themeName).variables.initialized) {
                      this.themeService.changeTheme(user.settings.themeName);
                    }
                  }

                  return user

                  // Sentry.configureScope((scope) => {
                  //   scope.setUser({
                  //     'id': `${user?.documentId}`,
                  //     'username': `${user?.firstName} ${user?.lastName}`,
                  //     'email': user?.email
                  //   });
                  // });
                }
            });
    }
}
